/**
 * Splits a filename into a [filename, extension] tuple.
 *
 * @example
 * splitFileName("report.xlsx") // ["report", ".xlsx"]
 * splitFileName("no-extension") // ["no-extension", ""]
 */
export const splitExtension = (filename: string): [string, string] => {
  const trimmed = filename.trim();
  const lastDotIndex = trimmed.lastIndexOf(".");
  if (lastDotIndex <= 0) {
    return [trimmed, ""];
  }
  return [trimmed.substring(0, lastDotIndex), trimmed.substring(lastDotIndex)];
};
